export default __webpack_public_path__ + "static/media/calendar-icon.bd4d385b.svg";